export default __webpack_public_path__ + "static/media/fox_progress.27b1c906.png";